"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRequestData = exports.getRequestData = void 0;
let requestData = {};
function getRequestData(key) {
    return key ? requestData[key] : requestData;
}
exports.getRequestData = getRequestData;
function setRequestData(key, value) {
    if (value && requestData) {
        requestData[key] = value;
    }
    else if (!value) {
        //single argument = overwrite the whole array
        requestData = key;
    }
}
exports.setRequestData = setRequestData;
//# sourceMappingURL=RequestData.js.map